import { isEmpty } from 'lodash';
import { getValue } from '../../modules/crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../models/applicationDetailModel';
import * as actionTypes from '../types/applicationDetailTypes';

const initialState: ApplicationDetailModel = {
  _applicationDetail: {},
  getUserName(): string { return getValue(this._applicationDetail, '[\'userDetail\'][\'userName\']'); },
  getLoginName(): string { return getValue(this._applicationDetail, '[\'userDetail\'][\'loginName\']'); },
  getUserDetail(): any { return getValue(this._applicationDetail, '[\'userDetail\']'); },
  getHospitalDetail(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\']'); },
  getGroupProviders(): any { return getValue(this._applicationDetail, '[\'groupProviders\']'); },
  getUserRole(): any { return getValue(this._applicationDetail, '[\'userDetail\'][\'userRoles\']'); },
  getProviderName(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerName\']'); },
  getDefaultPayer(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'defaultConfiguredPayerId\']'); },
  getProfileId(): any { return getValue(this._applicationDetail, '[\'userDetail\'][\'profileId\']'); },
  getProviderId(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerId\']'); },
  getIPConfig(): any { return getValue(this._applicationDetail, '[\'userDetail\'][[\'properties\']][\'InPatientSearchParamList\']'); },
  getGrievanceConfig(): any {
    return getValue(this._applicationDetail,
     '[\'userDetail\'][[\'properties\']][\'GrievanceSearchParamList\']'); },
  getIPPreAuthViewConfig(): any { return getValue(this._applicationDetail, '[\'userDetail\'][[\'properties\']][\'PreAuthViewSearchParamList\']'); },
  getIPClaimViewConfig(): any { return getValue(this._applicationDetail,
     '[\'userDetail\'][[\'properties\']][\'ClaimViewSearchParamList\']'); },
  getReconciliationIPConfig(): any { return getValue(this._applicationDetail, '[\'userDetail\'][[\'properties\']][\'ReconciliationSelectedColumns\']'); },
  getUserId(): any { return getValue(this._applicationDetail, '[\'userDetail\'][\'userId\']'); },
  getUserEmail(): any { return getValue(this._applicationDetail, '[\'userDetail\'][\'emailId\']'); },
  getIsNewAutomationEnabled(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isNewAutomationEnabled\']'); },
  getIsTPADashboardEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isTPADashboardEnabled\']');
  },
  getIsSurveyEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isSurveyEnabled\']');
  },
  getHipId(): string { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'Hip_ID\']'); },
  getIsEmailVerified(): any { return getValue(this._applicationDetail, '[\'isEmailVerificationRequired\']'); },
  getIsPOIEnabledForHospital(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isPOIEnabled\']'); },
  getIsEasyDischargeEnabled(): any { return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isEasyDischargeEnabled\']'); },
  getIsHISSearchEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isHISIntegrationEnabled\']');
  },
  getIsNHCXEnabledProvider(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isNHCXEnabledProvider\']');
  },
  getIsDocumentChecklistEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isDocumentChecklistEnabled\']');
  },
  getIsDownloadClaimEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isDownloadClaimEnabled\']');
  },

  getClaimsViewConfig(): any { return getValue(this._applicationDetail,
    '[\'userDetail\'][[\'properties\']][\'ClaimsDisplayParamList\']'); },

  getIsNewMailboxConfigEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isNewMailboxConfigEnabled\']');
  },

  getIsPreAuthClaimViewEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isClaimPreAuthViewEnabled\']');
  },
  getTickerConfigurator(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'tickerConfigurations\']');
  },
  getIsPreAuthNewDesignEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isPreAuthNewDesignEnabled\']');
  },
  getIsInitialDischargeEnabledProvider(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isInitialDischargeEnabledProvider\']');
  },
  getIsUserEmailVerified(): boolean {
    return getValue(this._applicationDetail, '[\'userDetail\'][\'isEmailVerified\']');
  },
  getIsVersioningPostAPIEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isVersioningPostAPIEnabled\']');
  },
  getIsNewTpaDeskEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isNewTpaDeskEnabled\']');
  },
  getIsGrievanceEnabled(): boolean {
    return getValue(this._applicationDetail, '[\'providerConfigurableProperties\'][\'isGrievanceEnabled\']');
  },
  getIsHospitalSealFeatureEnabled(): boolean {
    return getValue(this._applicationDetail,
      '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isHospitalSealFeatureEnabled\']');
  },
  getIsDoctorSignatureFeatureEnabled(): boolean {
    return getValue(this._applicationDetail,
      '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isDoctorSignatureEnabled\']');
  },
  getConfiguredPayer(): any {
    return getValue(this._applicationDetail, '[\'configuredPayer\']');
  },
  getIsPatientSignEnabled(): boolean {
    return getValue(this._applicationDetail,
      '[\'hospitalDetail\'][\'providerConfigurableProperties\'][\'isPatientSignatureEnabled\']');
  },
  getIsNewTpaActiveForGroupProvider(): boolean {
    const applicationDetail = this._applicationDetail ?? {};
    const hospitalDetail = applicationDetail.hospitalDetail ?? {};
    const providerConfig = hospitalDetail.providerConfigurableProperties ?? {};
    const { isNewTpaDeskEnabled = false, isClaimPreAuthViewEnabled = false } =
      providerConfig;
    const groupProviders = applicationDetail.groupProviders ?? [];

    return (
      isNewTpaDeskEnabled &&
      isClaimPreAuthViewEnabled &&
      !isEmpty(groupProviders)
    );
  },
  getIsOrionIntegrationEnabled(): boolean {
    return getValue(this._applicationDetail.hospitalDetail, '[\'providerConfigurableProperties\'][\'isOrionEnabled\']');
  },
};

const reducer = (
  state: any = initialState,
  action: any,
): any => {
  if (action.type === actionTypes.SET_APPLICATION_DETAIL) {
    return {
      ...state,
      _applicationDetail: action.payload,
    };
  } else if (action.type === actionTypes.CLEAR_APPLICATION_DETAIL) {
    return {
      ...state,
      _applicationDetail: {},
    };
  } else if (action.type === actionTypes.UPDATE_IP_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.InPatientSearchParamList = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_IP_PRE_AUTH_VIEW_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.PreAuthViewSearchParamList = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_GRIEVANCE_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.GrievanceSearchParamList = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_IP_CLAIM_VIEW_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.ClaimViewSearchParamList = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_RECONCILIATION_IP_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.ReconciliationSelectedColumns = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_CLAIMS_DISPLAY_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.ClaimsDisplayParamList = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.SET_HIP_ID) {
    const updatedState = state;
    updatedState._applicationDetail.hospitalDetail.Hip_ID = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.SET_IS_HIS_SEARCH_ENABLED) {
    const updatedState = state;
    updatedState._applicationDetail.hospitalDetail.providerConfigurableProperties.isHISIntegrationEnabled = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_REPORTING_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.ReportingSearchParamList = action.payload;
    return {
      ...updatedState,
    };
  } else if (action.type === actionTypes.UPDATE_TAT_REPORTING_CONFIG) {
    const updatedState = state;
    updatedState._applicationDetail.userDetail.properties.ReportingTATConfigList = action.payload;
    return {
      ...updatedState,
    };
  } else {
    return state;
  }
};

export { reducer as applicationDetailReducer };
